// Source constants
export const SOURCE_ADDRESS_LIST = 'address-list';
export const SOURCE_CUSTOMER_DASHBOARD = 'customer-dashboard';
export const SOURCE_CUSTOMER_TABLE = 'customer-table';
export const SOURCE_RELATIONS_TABLE = 'customer-table';
export const SOURCE_CUSTOMER_VIEW = 'customer-view';
export const SOURCE_INVENTORY_TABLE = 'inventory-table';
export const SOURCE_INVENTORY_VIEW = 'inventory-view';
export const SOURCE_NOTES_TABLE = 'notes-table';
export const SOURCE_RECEIPT_VIEW = 'receipt-view';
export const SOURCE_RECEIPT_TABLE = 'receipt-table';
export const SOURCE_TRANSFER_NOTES_TABLE = 'transfer-notes-table';
export const SOURCE_TRANSFER_NOTE_MODAL = 'transfer-note-modal';
export const SOURCE_INVOICE_PAYMENTS_TABLE = 'invoice-payments-table';
export const SOURCE_SETTLEMENT_PAYMENTS_TABLE = 'settlement-payments-table';
export const SOURCE_FEATURE_REQUEST_TABLE = 'feature-request-table';
export const SOURCE_RECEIPT = 'receipt';
export const SOURCE_RECEIPT_DASHBOARD = 'receipt-dashboard';
export const SOURCE_LOTS_TABLE = 'lots-table';
export const SOURCE_BULK_CATEGORY_LOT_UP = 'bulk-category-lot-up';
export const SOURCE_LOT_UP_MODAL = 'lot-up-modal';
export const SOURCE_BIDDERS_TABLE = 'bidders-table';
export const SOURCE_BIDDERS_MODAL = 'bidders-modal';
export const SOURCE_RECEIPT_MODAL = 'receipt-modal';
export const SOURCE_CONDITION_REPORT_REQUEST_MODAL = 'condition-report-request-modal';
export const SOURCE_SALES_TABLE = 'sales-table';
export const SOURCE_SALES_VIEW = 'sales-view';
export const SOURCE_SALES_DASHBOARD = 'sales-dashboard';
export const SOURCE_SALE_TERM_VIEW = 'sales-term-view';
export const SOURCE_INVENTORY_DASHBOARD = 'inventory-dashboard';
export const SOURCE_INVENTORY_STATUS = 'inventory-status';
export const SOURCE_BRANCH_ITEM_LOCATIONS = 'branch-item-locations';
export const SOURCE_ITEM_LOCATION_MOVE_MODAL = 'item-location-move-modal';
export const SOURCE_RECEIPT_TYPEAHEAD = 'receipt-typeahead';
export const SOURCE_CATEGORY_VIEW = 'receipt-typeahead';
export const SOURCE_PRE_BIDS_TABLE = 'pre-bids-table';
export const SOURCE_INVOICES_TABLE = 'invoices-table';
export const SOURCE_INVOICE_TRANSACTION_EXPORTS= 'invoice-transaction-exports';
export const SOURCE_INVOICE_PAYMENT_EXPORTS= 'invoice-payment-exports';
export const SOURCE_SETTLEMENT_TRANSACTION_EXPORTS= 'settlement-transaction-exports';
export const SOURCE_SETTLEMENT_PAYMENT_EXPORTS= 'settlement-payment-exports';
export const SOURCE_RETURN_NOTES_TABLE = 'return-notes-table';
export const SOURCE_SETTLEMENTS_TABLE = 'settlements-tables';
export const SOURCE_VENDORS_TABLE = 'vendors-tables';
export const SOURCE_CUSTOMER_INVOICE_LIST = 'customer-invoice-list';
export const SOURCE_LIVE_BIDS = 'live-bids';
export const SOURCE_NEGOTIATIONS_MODAL = 'negotiations-modal';
export const SOURCE_AUDIENCES_LIST = 'audiences-list';
export const SOURCE_CAMPAIGNS_LIST = 'campaigns-list';
export const SOURCE_AUDIENCES_CUSTOMERS_LIST = 'audiences-customers-list';
export const SOURCE_AUDIENCE_CUSTOMERS = 'audienceCustomer';
export const SOURCE_RESERVATION_MODAL = 'reservation-modal';
export const SOURCE_CUSTOMER_BALANCE_PAGE = 'customer-balance-page';
export const SOURCE_BIDS_TABLE = 'bids-table';
export const SOURCE_TEMPORARY_ITEMS_TABLE = 'temporary-items-table';
export const SOURCE_TIMED_AUCTION_SETTINGS = 'timed-auction-settings';
export const SOURCE_TELEPHONE_BIDS_TABLE = 'telephone-bids-table';
export const SOURCE_BRANCH_CLERKS = 'branch-clerks';
export const SOURCE_REPORTS_LIST = 'reports-list';
export const SOURCE_BRANCH_CHARGES = 'branch-charges';
export const SOURCE_RESERVATION_SALE_SETTINGS = 'reservation-sale-settings'
export const SOURCE_RESERVATION_DASHBOARD = 'reservation-dashboard'
export const SOURCE_RESERVE_ITEMS_MODAL = 'reserveItemsModal';
export const SOURCE_GROUPED_ITEMS_RESERVE_MODAL = 'grouped-items-reserve-modal';
export const SOURCE_CONDITION_REPORTS_TABLE = 'condition-reports-table';
export const SOURCE_CONDITION_REPORTS_IMAGES_MODAL = 'condition-reports-images-modal';
export const SOURCE_CONDITION_REPORT_REQUESTS_TABLE = 'condition-report-requests-table';
export const SOURCE_DPV_HISTORY_TABLE = 'dpv-history';
export const SOURCE_AUCTION_DPV_TABLE = 'auction-dpv';
export const SOURCE_POLICE_BOOK_MODAL = 'source_police_book_modal'
export const SOURCE_CLS_TABLE = 'cls-table';
export const SOURCE_BATCH_MARK_UNSOLD_MODAL = 'batch-mark-unsold-modal';
export const SOURCE_CONTRACT_LIST = 'contract-list';
export const SOURCE_GENERAL_CONTRACT_MODAL = 'general-contract-modal';

// Web Socket constants
export const WS_CREATE_PRE_BID = 'create_pre_bid';
export const WS_UPDATE_PRE_BID = 'update_pre_bid';
export const WS_ON_AUCTION_CONSOLE_OPEN = 'on_auction_console_open';
export const WS_ON_AUCTION_CONSOLE_CLOSE = 'on_auction_console_close';
export const WS_ON_OVERDUE_NOTIFICATION_PROGRESS = 'overdue_notification_progress';
export const WS_ON_UNPAID_NOTIFICATION_PROGRESS = 'unpaid_notification_progress';
export const WS_LIVE_AUCTION_SYNC_PROGRESS = 'live_auction_sync_progress';
export const WS_AUCTION_CATALOG_GENERATION_PROGRESS = 'auction_catalog_generation_progress';
export const WS_INVENTORY_OVERVIEW_GENERATION_PROGRESS = 'inventory_overview_generation_progress';
export const WS_AUCTION_CSV_EXPORT_FINISH = 'auction_csv_export_finish';
export const WS_AUCTION_PDF_EXPORT_FINISH = 'auction_pdf_export_finish';
export const WS_AUCTION_XLSX_EXPORT_FINISH = 'auction_xlsx_export_finish';
export const WS_AUCTION_SALE_PROFILE_PDF_EXPORT_FINISH = 'auction_sale_profile_pdf_export_finish';
export const WS_AUCTION_AUCTIONEERS_BOOK_EXPORT_FINISH = 'auction_auctioneers_book_export_finish';
export const WS_BULK_EDIT_TEMPLATE_EXPORT_FINISH = 'bulk_edit_template_export_finish';
export const WS_BULK_EDIT_UPLOAD_PROGRESS = 'bulk_edit_upload_progress';
export const WS_BATCH_INVOICE_GENERATION_PROGRESS = 'batch_invoice_generation_progress';
export const WS_BATCH_SETTLEMENT_GENERATION_PROGRESS = 'batch_settlement_generation_progress';
export const WS_INVOICES_MERGED_PDF_PREVIEW_GENERATION_PROGRESS = 'invoices_merged_pdf_preview_generation_progress';
export const WS_SETTLEMENTS_MERGED_PDF_PREVIEW_GENERATION_PROGRESS = 'settlements_merged_pdf_preview_generation_progress';
export const WS_BATCH_LOT_UP_PROGRESS = 'batch_lot_up_progress';
export const WS_BATCH_UPDATE_LOT_FINANCIAL_TERMS = 'batch-update-lot-financial-terms'
export const WS_ACCOUNTING_SYNC_PROGRESS = 'accounting_sync_progress';
export const WS_DATA_COLLECTION_PROVIDER_PROGRESS = 'data_collection_provider_progress';
export const WS_LLP_LOT_STARTED = 'llp_lot_started';
export const WS_LLP_LOT_UPDATE = 'llp_lot_updated';
export const WS_LLP_AUCTION_UPDATE = 'llp_auction_updated';
export const WS_LLP_AUCTION_ENDED = 'llp_auction_ended';
export const WS_BATCH_REASSIGN_PROGRESS = 'batch_reassign_progress';
export const WS_LLP_BID_CREATED = 'llp_bid_created';
export const WS_LLP_AUCTION_SUBSCRIBED = 'llp_auction_subscribed';
export const WS_REPORT = 'report';
export const WS_EXPORT = 'export';
export const WS_CONTINUOUS_AUCTION_BATCH_LOT_UP_PROGRESS = 'continuous_auction_batch_lot_up_progress';
export const WS_INVENTORY_BULK_EDIT_PROGRESS = 'inventory_bulk_edit_progress';
export const WS_BULK_ADJUST_PRICES = 'reservation_bulk_adjust_prices_progress';
export const WS_INVENTORY_BATCH_LOT_UP_PROGRESS = 'inventory_batch_lot_up_progress';
export const WS_LOTS_BATCH_MARK_UNSOLD_PROGRESS = 'lots_batch_mark_unsold_progress';
export const WS_SEPA_GENERATION = 'settlement_generate_sepa';
export const WS_PADDLE_NUMBER_PRINT = 'paddle_number_print';
export const WS_KEEP_ALIVE = 'keep_alive';
export const WS_BULK_EDIT_INVOICES = 'invoices_bulk_edit_progress'
export const WS_AUCTIONEERS_SHEET_GENERATION_PROGRESS = 'auctioneers_sheet_generation_progress'
export const WS_POLICE_BOOK_PROGRESS = 'police_book_progress';
export const WS_BATCH_SHIPPING_IMPORT = 'batch_shipping_import_progress'
export const WS_TRANSFER_ACROSS_BRANCHES_PROGRESS = 'transfer_across_branches_progress';
export const WS_TRANSLATION_REQUEST = 'translation_request';
export const WS_BATCH_AUTO_PAYMENT_PROGRESS = 'batch_auto_payment_progress';
export const WS_BATCH_UPDATE_RECEIPT_PROGRESS = 'batch_update_receipt_progress';

// Inventory actions
export const ACTION_INVENTORY_CREATE_AND_DUPLICATE = 'create-and-duplicate'
export const ACTION_INVENTORY_GROUP_ITEMS = 'group-items'
export const ACTION_INVENTORY_CONT_AUCTION_BATCH_LOT_UP = 'continuous-auction-batch-lot-up'
export const ACTION_INVENTORY_SYNC_WITH_FULCRUM = 'sync-with-fulcrum'
export const ACTION_INVENTORY_BATCH_DELETE = 'delete'
export const ACTION_INVENTORY_ARCHIVE = 'archive'
export const ACTION_INVENTORY_UNARCHIVE = 'unarchive'
export const ACTION_INVENTORY_REMOVE_SOURCE_ITEM = 'action_remove_source_item'
export const ACTION_INVENTORY_TRANSFER_ACROSS_BRANCHES = 'inventory-transfer-across-branches';
export const ACTION_INVENTORY_BATCH_UPDATE_RECEIPT = 'inventory-batch-update-receipt';


// Invoice actions constants
export const ACTION_SEND_OVERDUE_EMAILS = 'send-overdue-emails';
export const ACTION_SEND_SECOND_OVERDUE_EMAILS = 'send-second-overdue-emails';
export const ACTION_SEND_THIRD_OVERDUE_EMAILS = 'send-third-overdue-emails';
export const ACTION_SEND_UNPAID_EMAILS = 'send-unpaid-emails';
export const ACTION_CREATE_NEW_INVOICE = 'new-invoice';
export const ACTION_CREATE_MANUAL_INVOICE = 'new-manual-invoice';
export const ACTION_CREATE_SERVICE_INVOICE = 'new-service-invoice';
export const ACTION_CREATE_DEPOSIT_INVOICE = 'new-deposit-invoice';
export const ACTION_BATCH_INVOICE_GENERATE = 'batch-generation';
export const ACTION_CANCEL_INVOICE = 'invoice-cancellation';
export const ACTION_PAY_INVOICE = 'invoice-payment';
export const ACTION_REFUND_INVOICE = 'invoice-refund';
export const ACTION_MARK_INVOICE_DISPATCHED = 'mark-invoice-dispatched';
export const ACTION_UNMARK_INVOICE_DISPATCHED = 'unmark-invoice-dispatched';
export const ACTION_SHOW_INVOICE_PAYMENTS_MODAL = 'show-invoice-payments-modal';
export const ACTION_SHOW_INVOICE_ALLOCATE_OVERPAYMENT = 'show-invoice-allocate-overpayment';
export const ACTION_SHOW_INVOICE_SHIPPING_MODAL = 'show-invoice-shipping-modal';
export const ACTION_SHOW_CANCEL_INVOICE_MODAL = 'show-cancel-invoice-modal';
export const ACTION_COLLECTED = 'collected';
export const ACTION_APPROVE_INVOICES = 'approve-invoices';
export const ACTION_APPROVE_AUTO_PAYMENT = 'approve-auto-payment';
export const ACTION_SYNC_WITH_ACCOUNTING_SYSTEM = 'sync-with-accounting-system';
export const ACTION_SHOW_LIST_NOTES_MODAL = 'show-list-notes-modal';
export const ACTION_SHOW_INVOICE_ACTIVITIES_MODAL = 'show-invoice-activities-modal';
export const ACTION_CREATE_CREDIT_NOTE = 'create-credit-note';
export const ACTION_SEND_CREATE_CREDIT_EMAILS = 'send-credit-note-emails';
export const ACTION_BATCH_SETTLEMENT_GENERATE = 'batch-settlement-generation';
export const ACTION_GENERATE_COLLECTION_NOTE = 'action-generate-collection-note';
export const PREVIEW_ALL = 'preview-all';
export const DOWNLOAD_PDF = 'download-pdf';
export const ACTION_INVENTORY_BULK_EDIT = 'inventory-bulk-edit';
export const ACTION_INVENTORY_BULK_RELOCATE = 'inventory-bulk-relocate';
export const ACTION_INVENTORY_GENERATE_BULK_QR_CODES = 'inventory-generate-bulk-qr-codes';
export const ACTION_INVENTORY_GENERATE_WEBAPP_QR_CODES = 'inventory-generate-webapp-qr-codes';
export const ACTION_INVENTORY_GENERATE_TRANSFER_NOTE = 'inventory-generate-transfer-note';
export const ACTION_INVENTORY_RETURN_ITEMS = 'inventory-return-items';
export const ACTION_INVENTORY_EXPORT_INVENTORY_OVERVIEW = 'export-inventory-overview';
export const ACTION_APPROVE_SETTLEMENT = 'approve-settlements';

export const ACTION_BULK_EDIT_INVOICES = 'bulk-edit-invoices'
export const ACTION_GENERATE_INVOICE_BATCH_PAYMENTS = 'generate-invoice-batch-payments'
export const ACTION_BATCH_SHIPPING_CHARGES = 'batch-shipping-charges';
export const ACTION_SEND_COLLECTION_APPOINTMENT_NOTIFICATION = 'send-collection-appointment-notification'

// Lot Actions
export const ACTION_LOT_UP = 'lot-up';
export const ACTION_LOT_UP_USING_QR = 'lot-up-using-qr';
export const ACTION_BATCH_LOT_UP = 'batch-lot-up';
export const ACTION_BATCH_UPDATE_AUCTION_LOT_IMAGES = 'batch-auction-lot-images';
export const ACTION_LOT_UPLOAD_IMAGES = 'upload-images';
export const ACTION_LOT_UPLOAD_ZIP = 'upload-zip';
export const ACTION_LOT_UP_USING_EXCEL = 'lot-up-using-excel';
export const ACTION_MARK_UNSOLD = 'mark-unsold';
export const ACTION_BATCH_MARK_UNSOLD = 'batch-mark-unsold'
export const ACTION_BATCH_WITHDRAW = 'batch-withdraw';
export const ACTION_GENERATE_LOT_PRINTOUTS = 'generate-lot-printouts';
export const ACTION_DELETE_LOT = 'delete-lot';
export const ACTION_LOT_EXPORT_ALL_IMAGES = 'lot-export-all-images';
export const ACTION_INVENTORY_EXPORT_IMAGES = 'inventory-export-images';
export const ACTION_PUBLISH_LOT = 'publish-lot';
export const ACTION_SYNC_LOTS = 'sync-lots';
export const ACTION_ARCHIVE_LOT = 'archive-lot';
export const ACTION_REVERT_TO_COMPLETED_LOT = 'revert-to-completed-lot';
export const ACTION_REASSIGN_SALE = 'reassign-sale';
export const ACTION_RESERVE_ITEMS = 'reserve-items';
export const ACTION_EXPORT_LOT_IMAGES = 'export-lot-images';
export const ACTION_BULK_ADJUST_PRICE = 'bulk-adjust-price';
export const ACTION_BATCH_UPDATE_SESSION = 'batch-update-sessions';
export const ACTION_BATCH_UPDATE_COLLECTION = 'batch-update-collection';
export const ACTION_BATCH_FINANCIAL_UPDATE = 'batch-financial-update';
export const ACTION_BATCH_UPDATE_HIDE_LOT = 'batch-update-hide-lot';

// Settlement Actions
export const ACTION_CREATE_MANUAL_SETTLEMENT = 'new-manual-settlement';
export const ACTION_CREATE_AUCTION_INTRODUCTORY_SETTLEMENT = 'new-auction-introductory-settlement';
export const ACTION_CREATE_MANUAL_INTRODUCTORY_SETTLEMENT = 'new-manual-introductory-settlement';
export const ACTION_GENERATE_SETTLEMENT_BATCH_PAYMENTS = 'generate-settlement-payments';

// Bidder Actions
export const ACTION_CREATE_NEW_BIDDER = 'new-bidder';
export const ACTION_EDIT_BIDDER = 'edit-bidder';
export const ACTION_REMOVE_BIDDER = 'remove-bidder';

//model names
export const MODEL_NAME_INVENTORY_ITEM = 'inventoryitem';
export const MODEL_NAME_ITEM_LOCATION = 'itemlocation';
export const MODEL_NAME_RECEIPT = 'receipt';
export const MODEL_NAME_INVOICE = 'invoice';

//invoice types
export const INVOICE_TYPE_MANUAL = 'manual';
export const INVOICE_TYPE_AUCTION = 'auction';
export const INVOICE_TYPE_CREDIT_NOTE = 'credit_note';
export const INVOICE_TYPE_DEPOSIT = 'deposit';
export const INVOICE_TYPE_SERVICE = 'service';


// Settlement types
export const SETTLEMENT_TYPE_DEBIT_NOTE = 'debit_note';
export const SETTLEMENT_TYPE_AUCTION_INTRODUCTORY = 'auction_introductory';
export const SETTLEMENT_TYPE_AUCTION = 'auction';
export const SETTLEMENT_TYPE_MANUAL = 'manual';
export const SETTLEMENT_TYPE_MANUAL_INTRODUCTORY = 'manual_introductory';


//batch lot up table row colors
export const BATCH_LOT_UP_ROW_BACKGROUND_COLOR_RED = '#ffe3e3';
export const BATCH_LOT_UP_ROW_BACKGROUND_COLOR_YELLOW = '#fffbe7';
export const BATCH_LOT_UP_ROW_BACKGROUND_COLOR_GREEN = '#dbf3db';

// payment types
export const TYPE_PAYMENT = 'payment'
export const TYPE_REFUND = 'refund'

// post code providers
export const UK_POST_CODE_SEARCH_PROVIDER = "UKPostCodeSearchProvider"
export const NORWAY_POST_CODE_SEARCH_PROVIDER = "NorwayPostCodeSearchProvider"

// post code autocomplete forms
export const INVENTORY_FORM = 'inventory_form'
export const CUSTOMER_FORM = 'customer_form'
export const CUSTOMER_ADDRESS_FORM = 'customer_address_form'

// country code
export const UK_COUNTRY_CODE = 'GB'

export const CONTINUOUS_ACTION_LOT_EXPAND = 'auction.currency,auction.dates,lot.financial_item.invoice'

//Table names
export const RELATIONS_TABLE_NAME = 'relations'
export const BIDS_TABLE_NAME = 'bids'
export const BIDDERS_TABLE_NAME = 'bidders'
export const ACCOUNTING_TABLE_NAME = 'bidders'
export const CUSTOMER_TABLE_NAME = 'customer'
export const INVENTORY_TABLE_NAME = 'inventory'
export const INVOICE_TABLE_NAME = 'invoices'
export const CHECKS_TABLE_NAME = 'checks'
export const BACS_TABLE_NAME = 'bacs'
export const LOTS_TABLE_NAME = 'lots'

export const LOTS_UNSOLD = 'lots_unsold'
export const MARKETING_TABLE_NAME = 'marketing'
export const NOTIFICATION_ACTIVITY_TABLE_NAME = 'notificationActivity'
export const PRE_BIDS_TABLE_NAME = 'preBids'
export const RECEIPTS_TABLE_NAME = 'receipts'
export const INVOICE_PAYMENTS_TABLE_NAME = 'invoicePayments'
export const SETTLEMENT_PAYMENTS_TABLE_NAME = 'settlementPayments'
export const FEATURE_REQUEST_TABLE_NAME = 'featureRequest'
export const TRANSFER_NOTES_TABLE_NAME = 'transferNotes'
export const SALES_TABLE_NAME = 'sales'
export const SETTLEMENTS_TABLE_NAME = 'settlements'
export const SEPA_TABLE_NAME = 'sepa'
export const VENDORS_TABLE_NAME = 'vendors'
export const VENDORS_UNSOLD_PROPOSALS_TABLE_NAME = 'unsoldProposals'
export const RETURN_NOTES_TABLE_NAME = 'returnNotes'
export const TELEPHONE_BIDS_TABLE_NAME = 'telephoneBids'
export const TEMPORARY_ITEMS_TABLE_NAME = 'temporaryItems'
export const POLICE_BOOKS_TABLE_NAME = 'policeBooks'
export const STATES_TABLE_NAME = 'states'
export const CONDITION_REPORTS_TABLE_NAME = 'conditionReports'
export const CONDITION_REPORT_REQUESTS_TABLE_NAME = 'conditionReportRequests'
export const MARKETING_CUSTOMER_TABLE_NAME = 'marketing.customer.'
export const USER_TABLE_NAME = 'setup/user'
export const VENDOR_CHARGES_TABLE_NAME = 'vendorCharges'
export const DPV_TABLE_NAME = 'dpv.dpv'
export const DPV_LOTS_TABLE_NAME = 'dpv/lots'
export const CLS_TABLE_NAME = 'cls'
export const CONTRACTS_TABLE_NAME = 'contracts'

// Sales Tax Configuration action buttons names
export const SALES_TAX_ADD_ACTION = 'add'
export const SALES_TAX_EDIT_ACTION = 'edit'
export const SALES_TAX_VIEW_DETAILS_ACTION = 'view-details'
export const SALES_TAX_DELETE_ACTION = 'delete'

//Timed auctions field hints
export const LOT_END_DATE_EXTENSION_HINT = "Time difference between end dates for consecutive lots. " +
    "Ex: If this is set to 30 Seconds and Lot #1 finishes at 01:00:00, lot #2 will finish at 01:00:30. " +
    "This extension applies by default. If you do not wish to apply this extension, please indicate 0 in the value. " +
    "For Bidlogix integration users, this field is same as By field.";

export const NUMBER_OF_LOTS_TO_EXTEND_HINT = "Following field defines how many lots will have their End Date extended per batch. " +
    "For example, if users indicate 3 lots in this field, Default Lot End Date Extension field will apply to 3 lots at a time. " +
    "For Bidlogix integration users, this field is same as Every field.";

export const BUY_NOW_CUT_OFF_TIME_HINT = "Usable for Bidlogix integration users only.";

export const BIDDING_EXTENSION_HINT = "Following field defines the extension time for when the last bid has been made on a lot. " +
    "This extension only applies if a last-minute bid is made on the lot.";

// Local storage
export const ARTISIO_IDLE_TRACKER_KEY = "artisio-idle-tracker"
export const PREFERRED_CAMERA_DEVICE_ID = "preferred_camera_device_id"
export const BLUV2_columns = "batch_lot_up_v2_columns"
export const ARTISIO_ACTIVE_LANGUAGE = "artisio_active_language"

// export const SAVED_SALE_UUID = "saved_sale_uuid"
export const SAVED_PADDLE_NUMBER = "saved_paddle_number"
export const IMPORTANT_INFO_DISMISSED = "important_info_dismissed"
export const RELEASE_NOTE_DISMISSED = 'release_note_dismissed'


export const ACTION_CREATE_NEW_CONDITION_REPORT = 'new-condition-report';
export const ACTION_EDIT_CONDITION_REPORT = 'edit-condition-report';
export const ACTION_REMOVE_CONDITION_REPORT = 'remove-condition-report';
